import { FC } from "react";

import TriangleWarningOutlineIcon from "@src/lib/icons/18px/triangle-warning-outline";
import AnimatedBanner from "@src/lib/ui/AnimatedBanner";

type Props = {
  firstSyncErrorAt: Date | null;
};

/**
 * Full-width warning banner shown when the builder-actions autosave
 * queue has been unable to flush to the server. Callers read
 * `firstSyncErrorAt` from their own sync store (LI or workflow)
 * and pass it in; the banner shows itself while that value is set.
 */
const BuilderActionSyncingErrorBanner: FC<Props> = ({ firstSyncErrorAt }) => (
  <AnimatedBanner
    showBanner={!!firstSyncErrorAt}
    icon={<TriangleWarningOutlineIcon className="size-4" />}
    text="Encountered unexpected error syncing updates to server. Please refresh if this continues."
    backgroundColor="var(--red-4)"
    color="var(--red-10)"
    borderRadius={0}
  />
);

export default BuilderActionSyncingErrorBanner;
